import { render, staticRenderFns } from "./activity_wcz.vue?vue&type=template&id=01297d82&"
import script from "./activity_wcz.vue?vue&type=script&lang=js&"
export * from "./activity_wcz.vue?vue&type=script&lang=js&"
import style0 from "./activity_wcz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports